import type { FeatureCollection } from 'geojson';

import { apiClient } from './apiClient';
import { normaliseFeatureCollectionResponse } from './geoJsonUtils';

/**
 * Fetches all water fittings for the given client from the backend.
 * Passes `clientId` as a query parameter so the ExternalAPI can scope the response
 * to the selected client rather than the caller's JWT claim client.
 * Returns a normalised GeoJSON FeatureCollection; never throws for invalid data.
 */
export async function fetchFittingsForClient(clientId: string): Promise<FeatureCollection> {
    const response = await apiClient.get<unknown>('/waterfittings', { params: { clientId } });
    return normaliseFeatureCollectionResponse(response.data);
}

export async function fetchFittingsForViewport(clientId: string, bbox: string): Promise<FeatureCollection> {
    const response = await apiClient.get<unknown>(`/waterfittings/md/${encodeURIComponent(bbox)}`, {
        params: { clientId },
    });
    return normaliseFeatureCollectionResponse(response.data);
}
